import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

/**
 * Component displayed when a user tries to access a route or feature
 * they don't have permission for.
 */
@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatIconModule,
    MatButtonModule
  ],
  template: `
    <div class="access-denied">
      <mat-icon class="access-denied__icon">lock</mat-icon>
      <h1 class="access-denied__title">Access Denied</h1>
      <p class="access-denied__message">
        You do not have permission to view this page.
      </p>
      <p class="access-denied__hint">
        Please contact your administrator if you believe you should have access to this resource.
      </p>
      <button mat-raised-button color="primary" routerLink="/dashboard">
        Go to Dashboard
      </button>
    </div>
  `,
  styles: [`
    .access-denied {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      text-align: center;
      padding: 24px;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    }
    
    .access-denied__icon {
      font-size: 96px;
      width: 96px;
      height: 96px;
      color: #f44336;
      margin-bottom: 24px;
      animation: pulse 2s ease-in-out infinite;
    }
    
    .access-denied__title {
      font-size: 36px;
      font-weight: 600;
      margin: 0 0 16px 0;
      color: #333;
    }
    
    .access-denied__message {
      font-size: 18px;
      color: #666;
      margin: 0 0 12px 0;
      max-width: 500px;
    }
    
    .access-denied__hint {
      font-size: 14px;
      color: #999;
      margin: 0 0 32px 0;
      max-width: 500px;
    }
    
    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.05);
        opacity: 0.8;
      }
    }
  `]
})
export class AccessDeniedComponent {}

